export const DOwNLOAD_FILE_FAILURE = 'DOwNLOAD_FILE_FAILURE';

export const downloadFileFailure = error => ({
    type: DOwNLOAD_FILE_FAILURE,
    payload: error,
    error: true,
});
